import React from 'react';

import { Skeleton } from 'src/component/ds/ui/skeleton';

/**
 * Stands in for the tile grid.
 *
 * @param {object} props component props
 * @param {number} props.count tiles on a full carousel page, so the layout doesn't shift when counts land
 * @returns {JSX.Element} tile-sized placeholders
 */
export function TilesSkeleton ({ count }: { count: number }) {
  return (
    <>
      {Array.from({ length: count }, (_, idx) => (
        <Skeleton key={idx} className='ds-h-[89px] ds-w-full' data-testid='alarm-volume-tile-skeleton' />
      ))}
    </>
  );
}
